export default {"src":"/_next/static/media/purina.bf478426.svg","height":35,"width":111,"blurWidth":0,"blurHeight":0};